import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { toString, pareseDate } from "./commands";
import { useStateStrict } from "@ajayvikas/react-common";
import { isDateEqual } from "@ajayvikas/common-utils";
const getIsEqual = (culture) => {
    return (left, right) => {
        const leftDate = pareseDate(culture, left);
        const rightDate = pareseDate(culture, right);
        return isDateEqual(leftDate, rightDate);
    };
};
export const DateInput = React.forwardRef((props, forwardRef) => {
    const { onInput, onChange, onBlur, onFocus, defaultValue, style, invalidDateAction = "rollback", invalidDateStyle, __fireOnChangeOnUnmount, value: propsValue, culture = "en-us", ...rest } = props;
    const isEqual = React.useMemo(() => getIsEqual(culture), [culture]);
    const [stateValue, setStateValue] = useStateStrict(() => toString(culture, propsValue), isEqual);
    const [isInvalid, setIsInvalid] = React.useState(false);
    React.useEffect(() => {
        setStateValue(toString(culture, propsValue));
    }, [culture, propsValue, setStateValue]);
    const onInputFocus = (e) => {
        if (isInvalid)
            setIsInvalid(false);
        onFocus?.(e);
    };
    const onInputInput = (e) => {
        const targetValue = e.target.value;
        setStateValue(targetValue);
        const inputDate = pareseDate(culture, targetValue);
        onInput?.(inputDate, e);
    };
    const onInputChange = (e) => {
        const raiseOnChangeEvent = (value, e) => {
            if (onChange && !isDateEqual(value, propsValue))
                onChange(value, e);
        };
        const inputDate = pareseDate(culture, stateValue);
        if (stateValue && !inputDate) {
            const dv = typeof defaultValue === "function" ? defaultValue() : defaultValue;
            if (dv) {
                setStateValue(toString(culture, dv));
                raiseOnChangeEvent(dv, e);
            }
            else {
                if (invalidDateAction === "clear") {
                    setStateValue("");
                    raiseOnChangeEvent(undefined, e);
                }
                else if (invalidDateAction === "default") {
                    const newValue = typeof defaultValue === "function" ? defaultValue() : defaultValue;
                    setStateValue(toString(culture, newValue));
                    raiseOnChangeEvent(newValue, e);
                }
                else if (invalidDateAction === "rollback") {
                    setStateValue(toString(culture, propsValue));
                    raiseOnChangeEvent(propsValue, e);
                }
                else if (invalidDateAction === "error") {
                    setIsInvalid(true);
                }
            }
        }
        else {
            raiseOnChangeEvent(inputDate, e);
        }
    };
    const onInputBlur = (e) => {
        onInputChange(e);
        onBlur?.(e);
    };
    // const onInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    //     if (e.key === "Enter") {
    //         const targetValue = (e.target as any).value;
    //         const dt = pareseDate(culture, targetValue);
    //         setStateValue(toString(culture, dt));
    //     }
    //     onKeyDown?.(e);
    // }
    const st = isInvalid ? (invalidDateStyle ?? INVALID_STYLE) : undefined;
    if (__fireOnChangeOnUnmount) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const onChangeRef = React.useRef(null);
        onChangeRef.current = onInputChange;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useEffect(() => {
            return () => {
                onChangeRef.current?.(undefined);
            };
        }, []);
    }
    return _jsx("input", { ...rest, ref: forwardRef, 
        // onKeyDown={onInputKeyDown}
        onChange: onInputInput, onFocus: onInputFocus, onBlur: onInputBlur, value: stateValue, style: { ...style, ...st } });
});
const INVALID_STYLE = { backgroundColor: "red", color: "white" };
